export default function AbilityPieChart({ data }) {
    const width = 150;
    return (
        <div className="w-[150px] max-w-[150px] flex justify-center items-center mt-[10px]">
            <div style={{ width: width, height: width }} className="relative">
                <svg width={width} height={width} viewBox="0 0 200 200">
                    <circle cx="100" cy="100" r="80" stroke="#E0E0E0" strokeWidth="20" fill="none" />
                    <circle
                        cx="100"
                        cy="100"
                        r="80"
                        stroke="#514FEC"
                        strokeWidth="30"
                        fill="none"
                        strokeDasharray={`${data?.count/(data?.total||1) * 2 * Math.PI * 80}, ${2 * Math.PI * 80}`}
                        transform="rotate(-90 100 100)"
                    />
                </svg>
                <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-[14px] font-[700] text-[#999] text-center'>
                    分數:<br />
                    <div className="text-[30px] text-[#1F4CC8] mt-[-10px]">{Math.round(data?.count/(data?.total||1)*100)}%</div>
                </div>
            </div>
        </div>
    )
}

